import { EmailCampaign } from '@spike/email-marketing-model';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableEmptyState } from 'components/UI/V3/Table/EmptyState/TableEmptyState';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { Table } from 'components/UI/V3/Table/Table';
import { FunctionComponent } from 'react';
import { SHOW_REVENUE_COLUMN } from './campaignsListFeatureFlags';
import EmailCampaignsRow from './Row/EmailCampaignsRow';
import styles from './EmailCampaignsList.module.scss';

interface EmailCampaignsListProps {
    campaigns: EmailCampaign[];
    hasCampaigns: boolean;
    page: number;
    totalPages: number;
    onChangePage: (page: number) => void;
    onEditCampaign: (campaign: EmailCampaign) => void;
    onDuplicateCampaign: (campaign: EmailCampaign) => void;
    onDeleteCampaign: (campaign: EmailCampaign) => void;
    /** Row click for `sent` campaigns → opens the Campaign Detail view. */
    onViewDetail: (campaign: EmailCampaign) => void;
}

const EmailCampaignsList: FunctionComponent<EmailCampaignsListProps> = ({
    campaigns,
    hasCampaigns,
    page,
    totalPages,
    onChangePage,
    onEditCampaign,
    onDuplicateCampaign,
    onDeleteCampaign,
    onViewDetail
}) => {
    if (!hasCampaigns) {
        return (
            <Table
                fullHeight
                className={styles.emptyState}
            >
                <TableBody>
                    <TableEmptyState>
                        <h1>No campaigns found</h1>
                        <p>Click the &quot;New Email Campaign&quot; button to start a new campaign</p>
                    </TableEmptyState>
                </TableBody>
            </Table>
        );
    }

    return (
        <Table
            fullHeight
            firstColumnFixed
            className={styles.table}
            pagination={{ page, totalPages }}
            onPageChange={onChangePage}
        >
            <TableHeader className={styles.tableHeader}>
                <TableHeaderCell>Campaign</TableHeaderCell>
                <TableHeaderCell>Delivered</TableHeaderCell>
                <TableHeaderCell>Open Rate</TableHeaderCell>
                <TableHeaderCell>Click Rate</TableHeaderCell>
                {SHOW_REVENUE_COLUMN && <TableHeaderCell>Revenue</TableHeaderCell>}
                <TableHeaderCell>Send Date</TableHeaderCell>
                <TableHeaderCell />
            </TableHeader>
            <TableBody>
                {campaigns.map(campaign => (
                    <EmailCampaignsRow
                        key={campaign.id ?? campaign.uuid}
                        campaign={campaign}
                        onEditCampaign={() => onEditCampaign(campaign)}
                        onDuplicateCampaign={() => onDuplicateCampaign(campaign)}
                        onDeleteCampaign={() => onDeleteCampaign(campaign)}
                        onViewDetail={() => onViewDetail(campaign)}
                    />
                ))}
            </TableBody>
        </Table>
    );
};

export default EmailCampaignsList;
